export const getDefault = <T>(val: T | undefined, defaultVal: T): T => {
    if (!val) {
        return defaultVal;
    }
    return val;
};
